// extracted by mini-css-extract-plugin
export default {"container":"sp-z","ratingLayout":"tp-z","ratingLabel":"up-z","nonInteractiveRatingLabel":"vp-z"};